<template>
  <div class="common-dialog chapters-List-dialog">
    <button class="close" @click="close">
      <icon-close></icon-close>
    </button>
    <div class="row no-gutters share-content">
      <div class="list" v-for="chapter in chapters" :key="chapter.startTime">
        <a class="app-item" href="javascript:;" @click="chapterGoTo(chapter.startTime)">
         <span class="time">{{ chapter.startTime | formatDuration}}</span> <span class="title">{{chapter.title}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import IconClose from "./icons/IconClose";
import { mapState } from "vuex";
import {MUTATION_UPDATE} from "@/store/mutations";
export default {
  name: "ChaptersListDialog",
  components: {IconClose},
  computed: {
    ...mapState(["chapters"]),
  },
  methods: {
    chapterGoTo(seconds){
      this.$emit('seek-to-chapter-time',seconds);
    },
    close() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", false]);
      this.$emit('hide');
    },
  }
}
</script>

<style scoped lang="scss">
.chapters-List-dialog {
  position: absolute;
  top: 0;
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  z-index: 9999;
  right: 0;
  left: 0;

  .close {
    color: #f8f8f8;

    &:hover {
      opacity: 0.8;
    }

    &:focus {
      opacity: 0.8;
      outline: -webkit-focus-ring-color auto 1px;
    }
  }

  .time {
    padding-right: 5px;
  }

  .title {
    font-weight: 600;
  }

  .share-content {
    display: block;
    padding: 0 25px;
    max-height: 130px;
    overflow: auto;
    margin-top: 10px;
    margin-bottom: 10px;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: rgba(0, 0, 0, 0.1);
    }

    .share-dialog {
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(200, 200, 200, 0.1);
        border-radius: 0;
        background: rgba(220, 220, 220, 0.1);
      }
    }

    a {
      &:hover {
        text-decoration: none;
        opacity: 0.7;
      }
    }

    .list {
      margin-bottom: 5px;

      span {
        color: #1a1a1a;
        font-size: 12px;
      }
    }
  }

  @media (max-width: 599px) {
    .share-dialog {
      .share-content {
        padding: 0 20px;
      }
    }
  }
}
</style>

